import { ForwardedRef, forwardRef } from 'react';

import { getCurrencyList } from '@ingrid/localization';

import { SimpleSearchSelect } from '~src/components/SimpleSearchSelect/SimpleSearchSelect';
import { useTranslation } from '~src/i18n/use-translation';

interface Props {
  onChange: (value: string) => void;
  disabled?: boolean;
  invalid?: boolean;
  value?: string;
}

function CurrencySelectElement(props: Props, ref: ForwardedRef<HTMLButtonElement>) {
  const { value, invalid, onChange, disabled = false } = props;
  const { i18n } = useTranslation();

  return (
    <SimpleSearchSelect
      options={getCurrencyList(i18n.resolvedLanguage!).map(([a]) => [a, a])}
      onValueChange={value => onChange(value[0])}
      value={value ? [value] : undefined}
      disabled={disabled}
      invalid={invalid}
      ref={ref}
    />
  );
}

export const CurrencySelect = forwardRef(CurrencySelectElement);
